import { combineReducers } from 'redux';

import { currentMarketReducer } from './currentMarket';
import { listedMarketsReducer } from './listed/listedMarketsReducer';
import { marketsSidebarReducer } from './marketsSidebar';
import { userHideOtherMarketsReducer } from './userHideOtherMarkets';
import { userTickSizeReducer } from './userTickSize/userTickSizeReducer';

export const marketsReducer = combineReducers({
  listedMarkets: listedMarketsReducer,
  marketsSidebar: marketsSidebarReducer,
  currentMarket: currentMarketReducer,
  userMarketTickSize: userTickSizeReducer,
  userHideOtherMarkets: userHideOtherMarketsReducer,
});
